"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CameraOffState = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CameraOffStateStyled = require("./CameraOffState.styled.js");
var _Avatar = require("../Avatar");
var _propTypes = require("prop-types");
var _styledComponents = require("styled-components");
var _BrandContext = _interopRequireDefault(require("../../contexts/BrandContext"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var CameraOffState = exports.CameraOffState = function CameraOffState(props) {
  var isStage = props.isStage,
    user = props.user,
    height = props.height,
    width = props.width,
    style = props.style;
  var brandContext = (0, _react.useContext)(_BrandContext["default"]);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: brandContext ? brandContext : {}
  }, /*#__PURE__*/_react["default"].createElement(_CameraOffStateStyled.BrandedAvatarContainer, {
    height: height,
    width: width,
    "data-testid": "branded-avatar-container",
    style: style
  }, /*#__PURE__*/_react["default"].createElement(_CameraOffStateStyled.BlurBackgroundDiv, {
    user: user,
    height: height,
    width: width,
    "data-testid": "cameraoff-blur-background"
  }), /*#__PURE__*/_react["default"].createElement(_Avatar.BrandedAvatar, {
    isStage: isStage,
    user: user,
    height: height,
    width: width
  })));
};
CameraOffState.propTypes = {
  isStage: _propTypes.PropTypes.bool,
  user: _propTypes.PropTypes.object.isRequired,
  height: _propTypes.PropTypes.string.isRequired,
  width: _propTypes.PropTypes.string.isRequired,
  style: _propTypes.PropTypes.object
};